import React, {useState, useEffect, useCallback, useMemo} from 'react'
import {useIntl} from 'react-intl'
import {AuditModal, KTCard, KTCardBody, Table, Loading} from '../../../components'
import {CustomCell} from '../../../components/Table/columns/CustomCell'
import {CustomCellDouble} from '../../../components/Table/columns/CustomCellDouble'
import {CustomHeader} from '../../../components/Table/columns/CustomHeader'
import {ListHeader} from '../../../components/Table/header/ListHeader'
import {ListLoading} from '../../../components/Table/ListLoading'
import {PageTitle} from '../../../core'

import {useDispatch, useSelector} from 'react-redux'
import {auditGetAll} from '../../../redux/slices/reporting.slice'
import {allUserLookup} from '../../../redux/slices/lookup.slice'

import {AuthType, AuditTypeSelect} from '../../../helpers'

import {
  useMemoizedStaticData
} from '../../../utils/performanceOptimizations'

const selectReportingData = (state) => ({
  audit: state.reporting.audit,
  loading: state.reporting.loading
})

const selectLookupData = (state) => ({
  allUserLookupList: state.lookup.allUserLookupList
})

function List() {
  const intl = useIntl()
  const {audit, loading} = useSelector(selectReportingData)
  const {allUserLookupList} = useSelector(selectLookupData)

  const dispatch = useDispatch()

  const [params, setParams] = useState()
  const [item, setItem] = useState(null)

  useEffect(() => {
    if (params) {
      dispatch(auditGetAll(params))
      dispatch(allUserLookup())
    }
  }, [dispatch, params])

  const handleSorting = useCallback((item) => {
    setParams((prevState) => ({...prevState, sort: item && item.sort, order: item && item.order}))
  }, [])

  const handleSearch = useCallback((item) => {
    setParams((prevState) => ({...prevState, name: item}))
  }, [])

  const handlePagination = useCallback((pagination) => {
    setParams((prevState) => ({...prevState, ...pagination}))
  }, [])

  const handleFilterSubmit = useCallback((values) => {
    setParams({...values})
  }, [])

  const handleItemClick = useCallback((data) => {
    setItem(data)
  }, [])

  const handleCloseModal = useCallback(() => {
    setItem(null)
  }, [])

  const columns = useMemo(() => [
    {
      Header: (props) => (
        <CustomHeader
          tableProps={props}
          handleChangeSorting={handleSorting}
          title={intl.formatMessage({id: 'REPORTING.AUDIT.FULLNAME'})}
          className='min-w-125px'
        />
      ),
      accessor: 'fullName',
      Cell: ({...props}) => (
        <CustomCell item={props} onClick={() => handleItemClick(props.data[props.row.index])} />
      ),
    },
    {
      Header: (props) => (
        <CustomHeader
          tableProps={props}
          handleChangeSorting={handleSorting}
          title={intl.formatMessage({id: 'REPORTING.AUDIT.TYPE'})}
          className='min-w-125px'
        />
      ),
      accessor: 'type',
      Cell: ({...props}) => (
        <CustomCell
          item={props}
          customValue={AuthType[`${props.data[props.row.index].type}`]}
          onClick={() => handleItemClick(props.data[props.row.index])}
        />
      ),
    },
    {
      Header: (props) => (
        <CustomHeader
          tableProps={props}
          handleChangeSorting={handleSorting}
          title={intl.formatMessage({id: 'REPORTING.AUDIT.CREATEDBY'})}
          className='min-w-125px'
        />
      ),
      accessor: 'createdBy',
      Cell: ({...props}) => (
        <CustomCellDouble
          item={props}
          double='dateTime'
          onClick={() => handleItemClick(props.data[props.row.index])}
        />
      ),
    },
  ], [intl, handleSorting, handleItemClick])

  const actionButtons = useMemoizedStaticData(() => [
    {
      title: 'FILTER',
      icon: '/images/icons/duotune/general/gen031.svg',
      variant: 'light-primary',
      list: [
        {
          title: 'REPORTING.AUDIT.USERID',
          data: allUserLookupList,
          name: 'userId',
        },
        {
          title: 'REPORTING.AUDIT.TYPE',
          data: AuditTypeSelect,
          name: 'type',
        },
        {
          title: 'REPORTING.AUDIT.DATEFROM',
          type: 'date',
          name: 'dateFrom',
        },
        {
          title: 'REPORTING.AUDIT.DATETO',
          type: 'date',
          name: 'dateTo',
        },
      ],
    },
  ], [allUserLookupList])

  const buttons = useMemo(() => [], [])

  return (
    <>
      <PageTitle>{intl.formatMessage({id: 'MENU.REPORTING.AUDIT'})}</PageTitle>
      <KTCard>
        <ListHeader
          search={handleSearch}
          actionButtons={actionButtons}
          onSubmit={handleFilterSubmit}
          buttons={buttons}
          pages={'AUDIT'}
        />
        <KTCardBody>
          {!audit && <ListLoading />}
          {audit && (
            <Table
              items={audit}
              cols={columns}
              handlePagination={handlePagination}
              paddless
            />
          )}
        </KTCardBody>
      </KTCard>

      <AuditModal
        onOpen={item ? true : false}
        onClose={handleCloseModal}
        oldData={item && item.oldValues}
        newData={item && item.newValues}
      />

      {loading && <Loading />}
    </>
  )
}
export {List}
